import React from 'react'
import { makeStyles } from '@material-ui/styles';
import { Typography } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';

const useStyles = makeStyles((theme) => ({
    contentComponentGrey:{  
       display: 'flex', 
       width:"100%",
       backgroundColor: theme.palette.background.grey,
       marginTop: theme.spacing(1.5), 
       marginBottom: theme.spacing(1.5),   
       padding: theme.spacing(1),
       borderRadius: "0.5rem",
       alignItems:'center'
    },

    contentComponentPink:{  
        display: 'flex', 
        width:"100%",
        backgroundColor: theme.palette.background.pink,
        marginTop: theme.spacing(1.5), 
        marginBottom: theme.spacing(1.5),   
        padding: theme.spacing(1),
        borderRadius: "0.5rem",
        alignItems:'center'
     },


    icon:{
        marginRight: theme.spacing(1.5), 
     },

     text: {
         margin:0,
         padding:0,
     }
}));

 
export default function WarnningBox(props) {
    const classes = useStyles();
    const {message, icon, backgroundColor} = props; 
    const showIcon = icon==undefined ? true:icon; 


    const classWarning =(background)=>{
            if(background=='pink'){
                return classes.contentComponentPink
            }
            return classes.contentComponentGrey
    } 

    return (
            <div className={classWarning(backgroundColor)}>
            {showIcon && 
             <ErrorIcon className={classes.icon} color='error'></ErrorIcon>  
            }
             <Typography variant ='body1' className={classes.text}>{message}</Typography>
            </div>
    )

}
